import { createSlice } from "@reduxjs/toolkit";
import { PaymentInitialLoad, PaymentPaggination } from "../thunk/PaymentThunk";



const initialState = {
    payments: [],
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};


export const PaymentSlice = createSlice({
    name: "payment",
    initialState,
    reducers: {
        resetPayment: (state, action) => {
            return {
                ...initialState
            };

        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(PaymentInitialLoad.pending, (state, action) => {
                return { ...state, showLoading: true };
            })
            .addCase(PaymentInitialLoad.fulfilled, (state, action) => {

                // console.log({ action });

                return {
                    ...state,
                    payments: action.payload,
                    errorMessage: '',
                    successMessage: '',
                    showLoading: false,
                };
            })
            .addCase(PaymentInitialLoad.rejected, (state, action) => {
                let errorMessage;
                if (action.payload) {
                    // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                    errorMessage = action.payload;
                } else {
                    errorMessage = action.error.message?.toString();
                }

                return { ...state, errorMessage, showLoading: false }
            })
            .addCase(PaymentPaggination.pending, (state, action) => {
                return { ...state, showLoading: true };
            })
            .addCase(PaymentPaggination.fulfilled, (state, action) => {

                // console.log({ action });

                return {
                    ...state,
                    payments: action.payload,
                    errorMessage: '',
                    successMessage: '',
                    showLoading: false,
                };
            })
            .addCase(PaymentPaggination.rejected, (state, action) => {
                let errorMessage;
                if (action.payload) {
                    // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                    errorMessage = action.payload;
                } else {
                    errorMessage = action.error.message?.toString();
                }

                return { ...state, errorMessage, showLoading: false }
            });
    },
});


export const { resetPayment } = PaymentSlice.actions;

export const PaymentReducer = PaymentSlice.reducer;